import Chip from 'tio-reimagined/components/chip';
import { Header, VStack } from 'tio-reimagined/components/layout';
import { LinkTo } from '@ember/routing';
import { PhWarningCircle } from 'ember-phosphor-icons';
import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';
import type { TOC } from '@ember/component/template-only';
import type TasApplicationModel from 'tio-data/models/tas-application';

interface S {
  Args: {
    model: TasApplicationModel;
  };
}

const tmpl: TOC<S> = <template>
  {{pageTitle (t "tuition_assistance.application_details.default")}}
  <VStack>
    <Header>
      <div class="tio-row-between flex-wrap gap-3">
        <div class="tio-row-tight flex-wrap">
          {{t "tuition_assistance.application_details.default"}}
          {{#if @model.migrationApplicationId}}
            <Chip @size="sm" @intent="success">
              {{t "tuition_assistance.migrated"}}
            </Chip>
          {{/if}}
          {{#if @model.isTrial}}
            <Chip @size="sm" @intent="danger">
              {{t "common.trial"}}
            </Chip>
          {{/if}}
        </div>
        {{#if @model.id}}
          <LinkTo
            @route="authenticated.admin.tas.applications.approval"
            @model={{@model.id}}
            class="tio-btn tio-btn--default tio-btn--outlined tio-btn--md"
            data-test-new-view-button
          >
            {{t "common.tas_approval_queue.new_view"}}
          </LinkTo>
        {{/if}}
      </div>
    </Header>

    <div
      class="tio-row-top rounded-xl border tio-border-warning tio-bg-warning-soft px-4 py-3 text-sm tio-fg-warning"
      role="alert"
    >
      <PhWarningCircle @size={{20}} class="mt-0.5 shrink-0 tio-fg-warning" />
      <div>
        <span class="font-semibold">{{t
            "tuition_assistance.applications.classic_view_deprecated.title"
          }}</span>
        {{t "tuition_assistance.applications.classic_view_deprecated.body"}}
        {{#if @model.id}}
          {{t "tuition_assistance.applications.classic_view_deprecated.cta_prefix"}}
          <LinkTo
            @route="authenticated.admin.tas.applications.approval"
            @model={{@model.id}}
            class="font-medium underline underline-offset-2 hover:tio-fg-warning-body"
          >{{t "tuition_assistance.applications.classic_view_deprecated.cta_link"}}</LinkTo>
          {{t "tuition_assistance.applications.classic_view_deprecated.cta_suffix"}}
        {{/if}}
      </div>
    </div>

    {{outlet}}
  </VStack>
</template>;

export default tmpl;
